<div class="flex">
    <div class="flex text-normal gap-3">
        <app-notifications-dropdown class="ml-4 z-10 flex items-center">
        </app-notifications-dropdown>
        <app-messages-dropdown [onlyOne]="true" class="z-10 ml-4 text-normal flex items-center pt-1" [forMobile] = "forMobile">
        </app-messages-dropdown>
        <div class="right-side md:hidden block mobile-menu text-normal">
            <a *ngIf="giftCount" class="help text-center text-normal font-20-21-iterstate gift-a"  [routerLink]="['/me/task-list']" style="font-size: 25px;position: relative;margin-right: 15px;">
                <span class="circle">{{giftCount}}</span>
                <i class="fa fa-gift"></i>
            </a>
        </div>
        <div class="md:block hidden">
            <app-dropdown>
                <div class="dropdown-button">
                    <div class="w-fit ml-2 flex text-normal justify-end gap-x-1 cursor-pointer" (click)="onOpenWidget()">
                        <div>
                            <app-image-wrapper [avatar]="avatarUrl" [class]="'rounded-full w-8 h-8 mt-1 m-auto'"></app-image-wrapper>
                        </div>
                        <div class=" text-xs py-1">
                            <div class="name md:block hidden overflow-ellipsis text-normal">{{nickname}}</div>
<!--                            <div class="name md:block hidden text-normal">{{balance + ' ' + ('ticket' | translate)}}</div>-->
<!--                            <div class="name md:block hidden text-normal">{{tickets + ('credit' | translate)}}</div>-->
                        </div>
                        <i class="fa fa-caret-down mt-4"></i>
                    </div>
                </div>
                <div class="dropdown-options">
                    <div class="absolute text-normal -left-36 top-full z-10 mt-3 w-60 overflow-hidden rounded-lg bg-card shadow-lg ring-1 ring-gray-900/5">
                        <div>
                            <ng-container *ngIf="!pubBool">
<!--                                <a [routerLink]="'/players/'+ authUser.userId" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">-->
<!--                                    <div class="flex  h-8 w-8 flex-none items-center justify-center rounded-lg text-normal bg-dark">-->
<!--                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                            <circle cx="12" cy="8" r="4" fill="currentColor"/>-->
<!--                                            <path d="M12 14C8.13 14 4.84 15.64 4.06 18H19.94C19.16 15.64 15.87 14 12 14Z" fill="currentColor"/>-->
<!--                                        </svg>-->
<!--                                    </div>-->
<!--                                    <div class="flex-auto">-->
<!--                                        <div class="block font-semibold text-normal">-->
<!--                                            {{'my_profile'| translate}}-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </a>-->
<!--                                <a [routerLink]="'/market/orders'" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">-->
<!--                                    <div class="flex h-8 w-8 flex-none items-center justify-center rounded-lg text-normal bg-dark ">-->
<!--                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                            <rect x="4" y="4" width="6" height="6" rx="1" fill="currentColor"/>-->
<!--                                            <rect x="4" y="14" width="6" height="6" rx="1" fill="currentColor"/>-->
<!--                                            <rect x="14" y="9" width="6" height="6" rx="1" fill="currentColor"/>-->
<!--                                            <path d="M10 7H14V9H10V7ZM10 17H14V15H10V17Z" fill="currentColor"/>-->
<!--                                        </svg>-->
<!--                                    </div>-->
<!--                                    <div class="flex-auto">-->
<!--                                        <div class="block font-semibold text-normal">-->
<!--                                            <span>{{'my_orders'| translate}}</span>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </a>-->
                                @if(platformAdminRole && (platformAdminRole === 'owner' || platformAdminRole === 'manager')){
                                    <a [routerLink]="'/admin/transactions'" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                                        <div class="flex h-8 w-8 flex-none items-center justify-center rounded-lg text-normal bg-dark">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 4H20V9C20 9.83 19.5 10.5 18.8 10.78C18.3 10.95 17.74 11 17 11H7C6.26 11 5.7 10.95 5.2 10.78C4.5 10.5 4 9.83 4 9V4Z" fill="currentColor"/>
                                                <path d="M4 12V20H20V12H4ZM10 14H14V18H10V14Z" fill="currentColor"/>
                                            </svg>
                                        </div>
                                        <div class="flex-auto">
                                            <div class="block font-semibold  text-normal">
                                                <span>{{'balance'| translate}}</span>
                                            </div>
                                        </div>
                                    </a>
                                    <a [routerLink]="'/admin/settings'" [routerLinkActive]="['text-primary']" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                                        <div class="flex h-8 w-8 flex-none items-center justify-center rounded-lg text-normal bg-dark">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5ZM19.43 12.98C19.46 12.66 19.5 12.34 19.5 12C19.5 11.66 19.46 11.34 19.43 11.02L21.54 9.64C21.73 9.5 21.78 9.23 21.67 9L19.67 5C19.56 4.77 19.29 4.67 19.05 4.78L16.63 5.93C16.09 5.58 15.52 5.29 14.9 5.07L14.59 2.5C14.55 2.22 14.32 2 14 2H10C9.68 2 9.45 2.22 9.41 2.5L9.1 5.07C8.48 5.29 7.91 5.58 7.37 5.93L4.95 4.78C4.71 4.67 4.44 4.77 4.33 5L2.33 9C2.22 9.23 2.27 9.5 2.46 9.64L4.57 11.02C4.54 11.34 4.5 11.66 4.5 12C4.5 12.34 4.54 12.66 4.57 12.98L2.46 14.36C2.27 14.5 2.22 14.77 2.33 15L4.33 19C4.44 19.23 4.71 19.33 4.95 19.22L7.37 18.07C7.91 18.42 8.48 18.71 9.1 18.93L9.41 21.5C9.45 21.78 9.68 22 10 22H14C14.32 22 14.55 21.78 14.59 21.5L14.9 18.93C15.52 18.71 16.09 18.42 16.63 18.07L19.05 19.22C19.29 19.33 19.56 19.23 19.67 19L21.67 15C21.78 14.77 21.73 14.5 21.54 14.36L19.43 12.98Z" fill="currentColor"/>
                                            </svg>
                                        </div>
                                        <div class="flex-auto">
                                            <div class="block font-semibold  text-normal">
                                                <span>{{'settings'| translate}}</span>
                                            </div>
                                        </div>
                                    </a>
                                }


                                <a  (click)="logOut()" class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm leading-6 hover:bg-card-hover">
                                    <div class="flex  h-8 w-8 flex-none items-center justify-center rounded-lg text-normal bg-dark">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 17L12 15L8 12L12 9L10 7L4 12L10 17Z" fill="currentColor"/>
                                            <path d="M16 5V19H20V5H16Z" fill="currentColor"/>
                                        </svg>

                                    </div>
                                    <div class="flex-auto">
                                        <div class="block font-semibold  text-normal">
                                            <span>{{'logout'| translate}}</span>
                                        </div>
                                    </div>
                                </a>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </app-dropdown>
        </div>
    </div>

    <div class="block md:hidden text-normal">
        <a id="nav-icon" (click)="openCloseMobileMenu()" style="display:block;" [ngClass]="showMobileMenu ? 'open' :''">
            @if(showMobileMenu){
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    <line x1="6" y1="18" x2="18" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>

            } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 100 100" fill="currentColor">
                    <circle cx="50" cy="30" r="15" fill="currentColor"/>
                    <ellipse cx="50" cy="70" rx="25" ry="15" fill="currentColor"/>
                    <circle cx="50" cy="50" r="48" stroke="currentColor" stroke-width="4" fill="none"/>
                </svg>
            }

        </a>

        <app-slider-side-menu [isShow]="showMobileMenu"  #sliderSideMenu >
            <div class="menu menu-mobile z-40">
                <div class="user-info text-center text-normal">
                    <app-image-wrapper [avatar]="avatarUrl" [fontSize]="40" [class]="'menu-mobile-main-avatar'" (click)='myProfil()'></app-image-wrapper>
                    <div class="name mt-1-0">{{nickname}}</div>
                    <div class="border-top-style ">
                        <div class="grid grid-cols-2">
                            <div class="text-center border-left-pink">
                                {{balance | currency : currency: 'Դ'}}
                            </div>
                            <div class="text-center">
                               <app-ticket [ticket]="tickets"></app-ticket>
                            </div>
                        </div>
                    </div>
                </div>

                <a (click)="onClose()"  [routerLink]="['/']" class="mobile-menu-link">{{'home'| translate}}</a>
<!--                <a (click)="onClose()"  [routerLink]="['/me/transactions']" class="mobile-menu-link">{{'transactions'| translate}}</a>-->
<!--                <a (click)="onClose()"  [routerLink]="['/me/settings']" class="mobile-menu-link">{{'settings'| translate}}</a>-->
<!--                <a (click)="onClose()" [routerLink]="['/me/edit-profile']" class="mobile-menu-link">{{'edit_profile'| translate}}</a>-->
                <a (click)="onClose()"  [routerLink]="['/me/edit-password']" class="mobile-menu-link">{{'change_password'| translate}}</a>
                <a (click)="logOut()" style="color:red;cursor: pointer" class="mobile-menu-link">{{'log_out'| translate}}</a>
                <hr/>
                <div class="footer-component-footer">
                    © CYBFED 2024, {{'all_rights_reserved' | translate}}
                </div>
            </div>
        </app-slider-side-menu>
    </div>
</div>

